export enum AdministrativeScope {
  INTERNATIONAL = 'international',
  NATIONAL = 'national',
  REGIONAL = 'regional',
  CITY = 'city',
}
